import styled from 'styled-components';
import {Space} from 'antd';
import {bordersStyles, typographyStyles} from '../../../../utils/styles';

const StyledInvoicePreview = styled(Space)`
  ${bordersStyles.light};
  ${typographyStyles.footnote.description};

  border: 1px solid ${props => props.theme.colors.neutral_3};
  color: ${props => props.theme.colors.neutral_10};
  display: flex;
  justify-content: space-between;
  margin-inline-end: 0;
  padding: 12px;
  width: 100%;

  .invoice-preview-title {
    .ant-space-item {
      display: flex;
      align-items: center;
    }
  }

  & > .ant-space {
    width: 100%;
  }

  .date {
    color: ${props => props.theme.colors.neutral_8};
  }

  .placeholder {
    height: 42px;
    width: 42px;
  }
`;

const StyledInvoicePreviewIcon = styled.div`
  align-items: center;
  display: flex;

  &:hover {
    cursor: pointer;
    svg {
      path {
        fill: ${props => props.theme.colors.neutral_7};
      }
    }
  }

  svg {
    height: 16px;
    width: 16px;
    path {
      fill: ${props => props.theme.colors.neutral_10};
      transition: .2s ease;
    }
  }
`;

export {
  StyledInvoicePreview,
  StyledInvoicePreviewIcon,
};
